import React, { useState } from 'react';
import { Box } from 'shared/components/display';
import AccountManagerForm, { AccountManagerFormData } from 'features/accounts/components/molecules/AccountManagerForm';
import { useAccounts } from 'features/accounts/hooks/useAccounts';
import Tags, { TagifySettings } from 'shared/components/atoms/Tags';
import Tag from 'shared/components/atoms/Tags/templates/Tag';
import { BrkfstAccount } from 'shared/typings/account';
import Divider from 'shared/components/molecules/Divider';
import { TEXT_VARIANTS } from 'shared/styles/text';
import styles from './styles';

interface Props {
  account: BrkfstAccount;
}
const AccountManagerSettings: React.FC<Props> = ({ account }) => {
  const [edit, setEdit] = useState(false);

  const { updateAccountManagers } = useAccounts();

  const accountManagers = (account.accountManagers || []).map((am) => am.name);

  const onSubmit = (values: AccountManagerFormData) => {
    updateAccountManagers(account.id, values.names);
    setEdit(false);
  };

  const onToggle = () => {
    setEdit((prev) => !prev);
  };

  const initialValues: AccountManagerFormData = {
    names: accountManagers,
  };

  return (
    <Box css={styles} className="account-manager-settings">
      <Divider
        heading="Account Manager"
        variant={TEXT_VARIANTS.H6}
        buttonText={edit ? 'Close' : 'Edit'}
        onClick={onToggle}
      />
      {edit ? (
        <AccountManagerForm onSubmit={onSubmit} initialValues={initialValues} accountId={account.id} />
      ) : accountManagers.length > 0 ? (
        <Tags value={accountManagers} settings={settings} readOnly />
      ) : (
        'No account managers assigned'
      )}
    </Box>
  );
};

const settings: TagifySettings = {
  templates: {
    tag: Tag,
  },
};

export default AccountManagerSettings;
